<template>
  <p class="scrub-input">
    <input type="range" v-bind:value="position" v-on:input="changed">
  </p>
</template>

<script>
export default {
  // Vue3: declare the emitted event (Scrubber emits `seeking` to media_player).
  emits: ['seeking'],
  props: ['position', 'playingLiveStream'],
  methods: {
    changed(ev) {
      if (this.playingLiveStream) {
        // prevent user from seeking during livestream
        ev.currentTarget.value = 0; // eslint-disable-line no-param-reassign
        return;
      }
      this.$emit('seeking', +ev.currentTarget.value);
    },
  },
};
</script>

<style lang="less" scoped>
  @track-color: fade(#999999, 50%);
  @thumb-color: #ffffff;

  @thumb-radius: 9px;
  @thumb-height: 16px;
  @thumb-width: 16px;
  @thumb-shadow-size: 1px;
  @thumb-shadow-blur: 2px;
  @thumb-shadow-color: fade(#000000,.5);
  @thumb-border-width: 1px;
  @thumb-border-color: #666666;

  @track-width: 100%;
  @track-height: 6px;
  @track-border-width: 1px;
  @track-border-color: #666666;

  @track-radius: 3px;
  @contrast: 5%;

  * {box-sizing: border-box; margin: 0; padding: 0;}


  /* Samples:
  http://danielstern.ca/range.css/#/
  https://css-tricks.com/styling-cross-browser-compatible-range-inputs-css/
  */

  .shadow(@shadow-size,@shadow-blur,@shadow-color) {
    box-shadow: @shadow-size @shadow-size @shadow-blur @shadow-color, 0px 0px @shadow-size lighten(@shadow-color,5%);
  }

  .track() {
    width: @track-width;
    height: @track-height;
    cursor: pointer;
    animate: 0.2s;
  }

  .thumb() {
    .shadow(@thumb-shadow-size,@thumb-shadow-blur,@thumb-shadow-color);
    border: @thumb-border-width solid @thumb-border-color;
    height: @thumb-height;
    width: @thumb-width;
    border-radius: @thumb-radius;
    background: @thumb-color;
    cursor: pointer;
  }

  input[type=range] {
    background: transparent;
    -webkit-appearance: none;
    margin: 0 0;
    padding: 0;
    width: @track-width;

    &:focus {
      outline: none;
    }

    &::-webkit-slider-runnable-track {
      .track();
      background: @track-color;
      border-radius: @track-radius;
      border: @track-border-width solid @track-border-color;
    }

    &::-webkit-slider-thumb {
      .thumb();
      -webkit-appearance: none;
      margin-top: ((-@track-border-width * 2 + @track-height) / 2) - (@thumb-height / 2);
    }

    &:focus::-webkit-slider-runnable-track {
      background: lighten(@track-color, @contrast);
    }

    &::-moz-range-track {
      .track();
      background: @track-color;
      border-radius: @track-radius;
      border: @track-border-width solid @track-border-color;
    }
    &::-moz-range-thumb {
      .thumb();
    }

    &::-ms-track {
      .track();
      background: transparent;
      border-color: transparent;
      border-width: @thumb-width 0;
      color: transparent;
    }

    &::-ms-fill-lower {
      background: darken(@track-color, @contrast);
      border: @track-border-width solid @track-border-color;
      border-radius: @track-radius*2;
    }

    &::-ms-fill-upper {
      background: @track-color;
      border: @track-border-width solid @track-border-color;
      border-radius: @track-radius*2;
    }

    &::-ms-thumb {
      .thumb();
    }

    &:focus::-ms-fill-lower {
      background: @track-color;
    }

    &:focus::-ms-fill-upper {
      background: lighten(@track-color, @contrast);
    }
  }

</style>
